import { FC } from 'react'

import { RequiredAsterisk } from '../../atoms/RequiredAsterisk'

import * as Styles from './styles'

interface Props {
  isInvalid?: boolean
  isRequired?: boolean
  errorMessage?: string
  children?: React.ReactNode
}

/**
 * The title to display for an individual embroidery section on the PDP.
 */
export const EmbroiderySectionTitle: FC<Props> = ({
  isInvalid,
  isRequired,
  errorMessage,
  children,
}) => {
  return (
    <Styles.SectionTitleWrapper data-testid='embroidery-section-title'>
      {children}
      {isRequired && <RequiredAsterisk />}
      {isInvalid && !!errorMessage && <Styles.RequiredText>{errorMessage}</Styles.RequiredText>}
    </Styles.SectionTitleWrapper>
  )
}
